import {INotificationValues} from "../../notifications/state/notifications_slice";

export const alertFormSuccess: INotificationValues = {type: "success", content: "Twoje zapytanie zostało wysłane."};
export const alertFormError: INotificationValues = {type: "warning", content: "Wystąpił problem przy wysłaniu zapytanie. Spróbuj ponownie."};
import {INotificationValues} from "../../notifications/state/notifications_slice";

export const alertFormSuccess: INotificationValues = {type: "success", content: "Twoje zapytanie zostało wysłane."};
export const alertFormError: INotificationValues = {type: "warning", content: "Wystąpił problem przy wysłaniu zapytanie. Spróbuj ponownie."};
